import React, { useState, useContext } from "react";
import { Image, Button, Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faShareFromSquare,
  faEdit,
  faTrash,
  faCog,
  faHeart as faHeartSolid,
  faComment,
  faScroll,
  faUsers,
  faVideo
} from "@fortawesome/free-solid-svg-icons";
import { faHeart as faHeartRegular } from "@fortawesome/free-regular-svg-icons";
import { useNavigate } from "react-router-dom";
import ShareModal from "./VisualModals/Share";
import DeleteModal from "./VisualModals/Delete";
import './CarouselVisCard.css';
import defaultThumbnail from '../assets/atom_science_logo.png';
import { APIEditPresentations } from "../helper/APIFunctions";
import { UserInfo } from "../helper/Context";
import { getColorForFolder, buildFolderTree } from "../helper/Utils";
import EditExplainerModal from "./EditExplainerModal";
import { ExplainerRecorder, getVideoOptions } from "./ExplainerRecorder";
const RenderFolderItems = ({ folders, onSelect, selectedFolder, level = 0 }) => {
  const prefix = "\u00A0\u00A0\u00A0\u00A0".repeat(level);
  return folders.map(folder => (
    <React.Fragment key={folder.id}>
      <Dropdown.Item onClick={() => onSelect(folder.id)}>
        {prefix}{folder.title}
      </Dropdown.Item>
      {folder.children && folder.children.length > 0 && (
        <RenderFolderItems folders={folder.children} onSelect={onSelect} selectedFolder={selectedFolder} level={level + 1} />
      )}
    </React.Fragment>
  ));
};

const CarouselExplainerCard = ({ explainer, onExplainerDelete, onExplainerEdit, isOrg, folders = [], folderTree = [], lockoutEdit = false, lockoutDelete = false, blockActions = false }) => {
  const [showShareModal, setShowShareModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isFavorite, setIsFavorite] = useState(explainer.favorite);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [recordChoice, setRecordChoice] = useState(null);
  const navigate = useNavigate();
  const { userInfo } = useContext(UserInfo);
  // const canEdit = (userInfo?.organization_permissions?.edit_presentations || !isOrg) && !lockoutEdit && !blockActions;
  const canDelete = (userInfo?.organization_permissions?.delete_presentations || !isOrg) && !lockoutDelete && !blockActions;
  const canEdit = false;
  // const canDelete = false;

  const handleToggleFavorite = () => {
    if (!canEdit) return;
    // const newFavoriteStatus = !isFavorite;
    // setIsFavorite(newFavoriteStatus);
    // APIEditPresentations(
    //   presentation.id, { favorite: newFavoriteStatus }, isOrg
    // ).then(() => {
    //     onPresEdit({ ...presentation, favorite: newFavoriteStatus });
    // }).catch((err) => {
//
    //     setIsFavorite(!newFavoriteStatus); // Revert on error
    // });
  };

  const handleMoveFolder = (newFolderId) => {
    if (!canEdit) return;
    // if (newFolderId === presentation.folder_id) return;
    // APIEditPresentations(
    //     presentation.id, { folder_id: newFolderId }, isOrg
    // ).then(() => {
    //   onPresEdit({ ...presentation, folder_id: newFolderId });
  };

  const handlePreview = (e) => {
    e.preventDefault();
    window.open(explainer.url, "_blank");
  };
  const folderName = folders.find(f => f.id === explainer.folder_id)?.title;
  const folderColor = getColorForFolder(explainer.folder_id, folderName);
  return (
    <>
      <div className={`carousel-vis-card ${isDropdownOpen ? 'dropdown-open' : ''}`}>
        <a 
          href={explainer.url} 
          onClick={handlePreview}
          className="carousel-vis-card-thumbnail-container"
        >
          <OverlayTrigger
            placement="top"
            delay={{ show: 1500, hide: 250 }}
            overlay={
              <Tooltip id={`tooltip-type-${explainer.id}`}>
                {explainer.type === "scrollytelling" ? "Scrollytelling Story" : "Explainer video"}
              </Tooltip>
            }
          >
            <span className="primary-card-overlay-icon">
              {explainer.type === "scrollytelling" ? (
                <FontAwesomeIcon icon={faScroll} />
              ) : (
                <img 
                  src="/snorkle_vis_thumbnails/AI-gen-explainer-icon-3.svg" 
                  alt="Explainer"
                  style={{ width: '1em', height: '1em' }}
                />
              )}
          </span>
          </OverlayTrigger>
          {isOrg && (
            <OverlayTrigger
              placement="top"
              delay={{ show: 1500, hide: 250 }}
              overlay={<Tooltip id={`tooltip-team-${explainer.id}`}>Team Presentation</Tooltip>}
            >
              <span className="secondary-card-overlay-icon">
              <FontAwesomeIcon icon={faUsers} />
              </span>
            </OverlayTrigger>
          )}
          <Image src={explainer.thumbnail || defaultThumbnail} className={`carousel-vis-card-thumbnail ${!explainer.thumbnail ? 'no-thumbnail' : ''}`} />
          {explainer.description ? <div className="carousel-vis-card-description">{explainer.description}</div> : null}
        </a>
        <div className="carousel-vis-card-body">
            <div className="d-flex justify-content-between align-items-start">
              <OverlayTrigger
                placement="top"
                delay={{ show: 1500, hide: 250 }}
                overlay={<Tooltip id={`tooltip-title-${explainer.id}`}>{explainer.title}</Tooltip>}
              >
                <h5 className="carousel-vis-card-title">{explainer.title}</h5>
              </OverlayTrigger>
              <OverlayTrigger
                placement="top"
                delay={{ show: 1500, hide: 250 }}
                overlay={<Tooltip id={`tooltip-favorite-${explainer.id}`}>{isFavorite ? 'Remove from favorites' : 'Add to favorites'}</Tooltip>}
              >
                <Button onClick={handleToggleFavorite} className="carousel-card-icon-button favorite-overlay-button" disabled={!canEdit}
                style={{
                  cursor: !canEdit ? 'default' : 'pointer',
                  pointerEvents: !canEdit ? 'none' : 'auto'
                }}>
                        <FontAwesomeIcon icon={isFavorite ? faHeartSolid : faHeartRegular} />
                </Button>
              </OverlayTrigger>
            </div>
          
          <div className="carousel-vis-card-meta mb-2">{(!canEdit) ?
            (<div className="vis-card-folder-label" style={{ borderLeft: `5px solid ${folderColor}`, pointerEvents: 'none' }}>
              {folderName || 'Uncategorized'}
            </div>)
            : (
            <Dropdown onToggle={setIsDropdownOpen}>
              <Dropdown.Toggle as="div" className="vis-card-folder-label" style={{ borderLeft: `5px solid ${folderColor}` }}>
                {explainer.folder_id ? folderName : 'Uncategorized'}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={() => handleMoveFolder(null)} disabled={!explainer.folder_id}>
                  Uncategorized
                </Dropdown.Item>
                <RenderFolderItems folders={folderTree || buildFolderTree(folders)} onSelect={handleMoveFolder} selectedFolder={explainer.folder_id} />
              </Dropdown.Menu>
            </Dropdown>
          )}
          </div>

          <div className="carousel-vis-card-actions">
            <OverlayTrigger
              placement="top"
              delay={{ show: 1500, hide: 250 }}
              overlay={<Tooltip id={`tooltip-share-${explainer.id}`}>Share</Tooltip>}
            >
            <span
              role="button"
              tabIndex="0"
              onClick={() => setShowShareModal(true)}
              onKeyDown={(e) => e.key === 'Enter' && setShowShareModal(true)}
              className="card-action-icon"
            >
              <FontAwesomeIcon icon={faShareFromSquare} />
            </span>
            </OverlayTrigger>
            <Dropdown onToggle={setIsDropdownOpen}>
              <OverlayTrigger
                placement="top"
                delay={{ show: 1500, hide: 250 }}
                overlay={<Tooltip id={`tooltip-settings-${explainer.id}`}>Settings</Tooltip>}
              >
                <Dropdown.Toggle as="span" className="card-action-icon" id="dropdown-basic">
                    <FontAwesomeIcon icon={faCog} />
                </Dropdown.Toggle>
              </OverlayTrigger>
                <Dropdown.Menu>
                    <Dropdown.Item onClick={() => setShowDeleteModal(true)} className="text-danger" disabled={!canDelete}>
                        <FontAwesomeIcon icon={faTrash} className="me-2" /> Delete
                    </Dropdown.Item>
                {(userInfo?.permissions?.edit_explainers) && (
                  <Dropdown.Item onClick={() => setShowEditModal(true)}>
                    <FontAwesomeIcon icon={faEdit} className="me-2" /> Edit Text
                  </Dropdown.Item>
                )}
                {explainer.can_record && !window.isMobile && getVideoOptions().map(option => (
                  <Dropdown.Item onClick={() => setRecordChoice(option)}>
                    <FontAwesomeIcon icon={faVideo} className="me-2" /> Record  Video ({option.width}x{option.height} {option.mime.split("/")[1]})
                  </Dropdown.Item>
                ))}
                </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </div>

      {showShareModal && <ShareModal
        show={showShareModal}
        onHide={() => setShowShareModal(false)}
        url={explainer.url}
        qr={explainer.qr_image}
        id={explainer.id}
        isExplainer={true}
      />}
      <DeleteModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        vis={explainer}
        onVisDelete={() => onExplainerDelete(explainer.id)}
        isOrg={isOrg}
        type="explainer"
      />
      {showEditModal && <EditExplainerModal
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
        onExplainerEdit={(explainer) => onExplainerEdit(explainer)}
        explainer={explainer}
      />}
      {
        recordChoice && <ExplainerRecorder
          show={recordChoice !== null}
          onHide={() => setRecordChoice(null)}
          explainer={explainer}
          videoMime={recordChoice.mime}         
          videoWidth={recordChoice.width}
          videoHeight={recordChoice.height}
        />
      }
    </>
  );
};

export default CarouselExplainerCard; 